import React from "react";
import EmptyValue from "../../../components/EmptyValue";
import { formatShortDate } from "../../../utils/format";
import { daysLeftUntil, isDelhiNcr } from "../../utils/priority";
import { salesPersonName } from "../../../utils/salesPerson";



function textOr(value) {
    return value || <EmptyValue />;
}

// Kept as a named export because src/v2/sales/pages/orders/columns.jsx imports it. The
// rule itself now lives in src/v2/utils/salesPerson.js, shared with the Quotations queue
// -- it prefers the attributed salesOwner and falls back to this genesis actorName, which
// is what stops the column going blank on the ~13k orders that predate attribution.
export function salesPerson(row) {
    return salesPersonName(row?.row?.original, "USER_ORDER");
}

export function buildExtraPharmacyOrderColumns() {
    return [
        {
            Header: "Contact",
            accessor: "contact",
            disableSortBy: true,
            Cell: (row) => textOr(row.row.original?.mapUserPatient?.Patient?.contact_no),
        },
        {
            Header: "Start Date",
            accessor: "startDate",
            // Sortable for real -- `startDate` is a DATE column on the base model
            // (classes/UserOrder/Constants.js in pillup-api), same reasoning as the
            // ops version of this column.
            Cell: (row) => textOr(formatShortDate(row.row.original?.startDate)),
        },
        {
            Header: "Order City",
            accessor: "city",
            disableSortBy: true,
            Cell: (row) => {
                const address = row.row.original?.address || {};
                return (
                    <span className="flex items-center gap-1.5">
                        {textOr(address.district)}
                        {isDelhiNcr({ city: address.district, state: address.state }) && (
                            <span className="rounded-[10px] bg-elm-100 px-1.5 py-0.5 text-[10px] font-semibold text-elm-700">
                                NCR
                            </span>
                        )}
                    </span>
                );
            },
        },
        {
            Header: "Days Left",
            accessor: "daysLeft",
            disableSortBy: true,
            Cell: (row) => {
                const left = daysLeftUntil(row.row.original?.endDate);
                if (left === null) return <EmptyValue />;
                if (left < 0) {
                    return <span className="font-semibold text-[#dc143c]">{Math.abs(left)}d over</span>;
                }
                return <span className={left <= 7 ? "font-semibold text-yellow-800" : undefined}>{left}d</span>;
            },
        },
        {
            Header: "Quotation Id",
            accessor: "quotationId",
            disableSortBy: true,
            Cell: (row) => textOr(row.row.original?.quotationId),
        },
        {
            Header: "Sales Person",
            accessor: "salesPerson",
            disableSortBy: true,
            Cell: (row) => textOr(salesPerson(row)),
        },
    ];
}
